import {Component, OnInit, ViewChild} from '@angular/core';
import {ExgModalService, ExgTableComponent, ExgTableSettingsComponent} from 'exc-controls-v2';
import {ExcRestService, IExcDataDistinct, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {EnumerationService} from '../services/enumeration.service';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ApplicationService} from '../services/application.service';
import {ExgApplicationEventEmitter} from '../misc/classes/ExgApplicationEventEmitter';
import {ExgEventArgs} from '../misc/classes/ExgEventArgs';
import {ExgApplicationTabService} from 'exc-tab-v2';

@Component({
  selector: 'app-oe-list',
  templateUrl: './oe-list.component.html',
  styles: [
  ]
})
export class OeListComponent extends ExcTranslation implements OnInit {
  @ViewChild('oeTable', {read: ExgTableComponent}) oeTable!: ExgTableComponent;
  @ViewChild(ExgTableSettingsComponent) VCtableDefinitionSettings!: ExgTableSettingsComponent;

  Events = new ExgApplicationEventEmitter();
  init = true;
  oeList = {
    selectKey: 'oeID',
    state: 1,
    selectedRow: undefined as any,
    searchValue: '',
    uiFilter: [] as any[],
    uiSort: [] as any[],
    ready: () => {
      if (!this.oeList.data || this.oeList.data.length === 0) {
        this.oeList.state = 2;
        this.oeTable.selectedRow = -1;
      } else {
        this.oeList.state = 0;
        this.oeTable.selectedRow = 0;
      }
      this.init = false;
    },
    selectionChanged: (index: number) => {
      this.oeList.selectedRow = this.oeList.data[index];
    },
    pageChanged: (page: number) => {
      if (this.oeList.MetaInfo.dataPaging !== undefined) {
        this.oeList.MetaInfo.dataPaging.pageNo = page;
      }
      this.oeList.loadData();
    },
    search: (value: string) => {
      this.oeList.searchValue = value;
      this.oeList.pageChanged(1);
    },
    loadData: () => {
      this.oeList.state = 1;
      const url = 'OER_List_CrmRolle';
      this.excRest
        .sget(
          this.excRest.computeUrl(url, {
            oe_CrmRolle: 0,
            fts: this.oeList.searchValue,
          }),
          'oeList',
          {
            MetaInfo: {
              dataPaging: this.oeList.MetaInfo.dataPaging,
              dataSort: this.oeList.MetaInfo.dataSort,
              dataFilter: this.oeList.MetaInfo.dataFilter
            }
          }
        )
        .subscribe((response) => {
          if (response.success && response.data) {
            this.oeList.data = response.data;
            this.oeList.paging = response.paging;
          } else {
            this.oeList.data = [];
            this.oeList.paging = {
              pagingPage: 0,
              pagingEndRow: 0,
              pagingPageSize: 25,
              pagingTotalPages: 0,
              pagingTotalRows: 0,
              pagingStartRow: 0,
            };
          }
          this.oeList.ready();
        });
    },
    data: [] as any,
    MetaInfo: {
      dataFilter: {} as IExcDataFilter,
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 25,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    distinctData: [],
    tableDef: [
      {caption: 'Name', value: 'AnzeigeName', fixed: false, align: 0, sort: 0, visible: true},
      {caption: 'Kurzbezeichnung', value: 'oeNPraefix', fixed: false, align: 0, sort: 0, visible: true},
      {caption: 'Rolle', value: 'CrmRolle', fixed: false, align: 0, sort: 0, visible: true},
      {caption: 'Typ', value: 'OeTyp', fixed: false, align: 0, sort: 0, visible: true},
      // {caption: 'Ort', value: 'adrOrt', fixed: false, align: 0, sort: 0, visible: true},
      // {caption: 'Land', value: 'adrLkz', fixed: false, align: 0, sort: 0, visible: true},
      // {caption: 'Bezeichnung', value: 'adrBez', fixed: false, align: 0, sort: 0, visible: true}
    ]
  };

  constructor(
    public excRest: ExcRestService,
    public excSecurity: ExcSecurityService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService,
    private modalSrv: ExgModalService,
    private exgApplicationTabService: ExgApplicationTabService
    ) {
    super();
  }

  ngOnInit(): void {
    this.registerEvents();
    this.initialize();
  }

  initialize(): void {
    this.oeList.loadData();
  }

  registerEvents(): void {
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      if (this.exgApplicationTabService.StateTab?.Active) {
        this.oeList.loadData();
      }
    });
    this.Events?.OE?.NewOE?.Save.subscribe((evt: ExgEventArgs) => {
      console.log(evt);
      this.oeList.loadData();
    });
  }

  openDetailsTab($event?: number): void {
    if ($event) {
      this.oeList.selectionChanged($event);
    }
    if (this.oeList.selectedRow) {
      this.appSvc.OE.Workspace.OpenTab(
        this.oeList.selectedRow?.oeID
      );
    }
  }

  getDistinctOE(dataDistinct: IExcDataDistinct): void {
    this.oeList.MetaInfo.dataDistinct = dataDistinct;
    const url = this.excRest.computeUrl('OER_List_CrmRolle');
    this.excRest
      .sget(
        this.excRest.computeUrl(url, {
          oe_CrmRolle: 0,
          fts: this.oeList.searchValue,
        }),
        'oeList',
        {
          MetaInfo: this.oeList.MetaInfo}).subscribe((response) => {
      this.oeList.distinctData = response.data;
    });
  }

  openNewOEModal(): void {
    this.appSvc.OE.OeEditor.OpenModal({isNew: true}, {Events: this.Events});
  }

  openUpdateModalOe(): void {
    if (this.oeList.selectedRow) {
      this.appSvc.OE.OeEditor.OpenModal({oeID: this.oeList.selectedRow?.oeID, isNew: false}, {Events: this.Events});
    }
  }

  openTableSettings($event: any): void {
    this.VCtableDefinitionSettings.openFilterConfig($event);
  }
}
